import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Button, Col, Form } from 'react-bootstrap'
import ModalCustom from '../../../../modal-custom'
import Error_false from '../../../../error/error-false'
import { createPropertyAssetAPI } from '../../../../../services/property'
import Error_500 from '../../../../error/error-500'
import SwalCustom from '../../../../../alert/swal-custom'

const schema = yup
  .object({
    assetId: yup.string().required('Please, Input your assets ID')
  })
  .required()

export default function AddAssetsTable({
  setIsSave,
  isSave,
  setIsRefresh,
  showAdd,
  setShowAdd,
  data
}) {
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const onSubmit = (d) => {
    const body = { ...data, ...d }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create Asset new?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'var(--comp-badge-color-background-primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    })
      .then((result) => {
        if (result.isConfirmed) {
          setIsSave(true)
          createAssetsTable(body)
        }
      })
      .then(() => {
        setIsRefresh(true)
      })
  }

  const createAssetsTable = async (body) => {
    try {
      const data = await createPropertyAssetAPI(body)

      if (data?.status) {
        SwalCustom({
          icon: 'success',
          title: 'Your asset has been saved',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          setIsRefresh(true)
        })
      } else {
        Error_false(data)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }

  const handleClose = () => {
    setShowAdd(false)
    // fnReset();
  }
  return (
    <ModalCustom width={500} open={showAdd} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Add Assets ID</label>

        <Col md={12}>
          <Controller
            name={'assetId'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.assetId?.message && (
            <label className="small text-danger">
              {errors.assetId.message}
            </label>
          )}
        </Col>

        <Col xl={12} className="text-center">
          <Button
            className="px-4 "
            disabled={isSave}
            type="submit"
            onClick={onSubmit}
          >
            {isSave ? 'Saving...' : 'Save'}
          </Button>
          <Button
            className="px-4 text-primary me-2"
            variant="light"
            type="button"
            disabled={isSave}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
